import React, { useState } from 'react';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/style/sales.module.scss';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import ReservInfoBottomsheet from './bottomsheet/ReservInfo';//매출상세내역-bottomsheet

export default function Sales(props) {
    const { data } = props;//props
    
    /* =============== 카테고리필터 =============== */
    const categoryFilter = (type) => {
        switch(type) {
            case 1 : return '엔진오일';
            case 2 : return '타이어';
            case 3 : return '정기점검';
            case 4 : return '기타';
        }
    }
    /* =============== 카테고리필터 =============== */
    /* =============== 상세내역 팝업오픈여부 =============== */
    const [ isOpen,setOpen ] = useState(false);
    const onDismissHandler = (value) => {
        setOpen(value);
    }
    /* =============== 상세내역 팝업오픈여부 =============== */

    return (
        <>
        <Element tag={`div`} anyprop={(e) => onDismissHandler(true)}>
            <Element tag={`div`} className={styles.infoArea}>
                <Element tag={`label`}>{data.MARKING_MEMBER_NAME}</Element>
                <Element tag={`span`} className={styles.center}>{categoryFilter(data.CATEGORY)}</Element>
                <Element tag={`span`} className={styles.center}>{data.REG_DT}</Element>
                <Element tag={`small`}>{data.PRICE}원</Element>
            </Element>
            <Element tag={`button`}><FontAwesomeIcon icon="fa-light fa-chevron-right" /></Element>
        </Element>
        {isOpen ? <ReservInfoBottomsheet isOpen={isOpen} onDismiss={onDismissHandler} data={data} /> : null}
        </>
    );
}